<ngx-extended-pdf-viewer
  [src]="pdfSrc"
  [height]="height"
  [formData]="pdfFormData"
  (formDataChange)="formDataChanged($event)"
  [showToolbar]="true"
  [showSidebarButton]="true"
  [showFindButton]="false"
  [showPagingButtons]="true"
  [showDrawEditor]="true"
  [showHighlightEditor]="false"
  [showStampEditor]="false"
  [showTextEditor]="true"
  [showZoomButtons]="true"
  [showPresentationModeButton]="false"
  [showOpenFileButton]="false"
  [showPrintButton]="true"
  [showDownloadButton]="true"
  [showSecondaryToolbarButton]="true"
  [showRotateButton]="undefined"
  [showRotateCwButton]="false"
  [showRotateCcwButton]="false"
  [showHandToolButton]="false"
  [showScrollingButton]="false"
  [showSpreadButton]="true"
  [showPropertiesButton]="false"
></ngx-extended-pdf-viewer>

<ng-container *ngIf="showDownloadButtons">
  <button (click)="logPdfBlob()">download blob</button>
  <button (click)="logPdfBase64()">download base64</button>
</ng-container>
